export const Step = {
  step: 1,
  dataTestid: "step-component",
  labelBy: "",
  label: "",
};
